export const actionTypes = {
  SELF_INSURANCE_TAXES_REQUEST_START: 'MY_TAXES.SELF_INSURANCE_TAXES.REQUEST_START',
  SELF_INSURANCE_TAXES_REQUEST_SUCCESS: 'MY_TAXES.SELF_INSURANCE_TAXES.REQUEST_SUCCESS',
  SELF_INSURANCE_TAXES_REQUEST_FAILURE: 'MY_TAXES.SELF_INSURANCE_TAXES.REQUEST_FAILURE',
};

export function startSelfInsuranceTaxesRequest() {
  return {
    type: actionTypes.SELF_INSURANCE_TAXES_REQUEST_START,
  };
}

export function requestSelfInsuranceTaxesSuccess(data) {
  return {
    type: actionTypes.SELF_INSURANCE_TAXES_REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestSelfInsuranceTaxesFailure(error) {
  return {
    type: actionTypes.SELF_INSURANCE_TAXES_REQUEST_FAILURE,
    payload: error,
  };
}
